<div class="container-fluid overflow-hidden py-4">
    <div class="row mb-3">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <h2 mat-dialog-title>{{title}}</h2>
    <mat-dialog-content>
        <div>{{body}}</div>
        <div class="row mt-3" *ngIf="registration">
            <div class="col-12">
                <h4>Refund Amount: ${{registration.cost | number:'1.2-2'}}</h4>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>Refund Reason (Optional)</mat-label>
                    <textarea matInput 
                        [(ngModel)]="refundReason" 
                        placeholder="Enter reason for refund"
                        rows="3"></textarea>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <div class="row mt-5">
        <div class="col-2">
            <button mat-raised-button (click)="refund()" [disabled]="isLoading">Refund</button>
        </div>
        <div class="col">
            <button mat-raised-button class="warning"
                (click)="dialogRef.close({status: 'cancel', message: 'Refunded was cancelled'})"
                [disabled]="isLoading">Cancel</button>
        </div>
    </div>
</div>